import { reactive } from 'vue';
import type { AuthPopinProps } from '@monolith/legacy/types/auth-popin';

type AuthPopinState = {
  isOpen: boolean;
  props: AuthPopinProps | null;
};

const authPopinState = reactive<AuthPopinState>({
  isOpen: false,
  props: null,
});

export function useAuthPopinState() {
  function openAuthPopinModal(props: AuthPopinProps): void {
    authPopinState.props = props;
    authPopinState.isOpen = true;
  }

  function closeAuthPopinModal(): void {
    authPopinState.isOpen = false;
    authPopinState.props = null;
  }

  return {
    state: authPopinState,
    openAuthPopinModal,
    closeAuthPopinModal,
  };
}
